import { createSlice } from '@reduxjs/toolkit';

const defaultModuleState = {
  filters: {},
  tempFilters: {},
  searchValue: '',
  currentPage: 1,
  rowsPerPage: 10,
  tableData: [],
  tableCount: null,
  lastFetchParams: null,
  classData: [], 
  statusCount: null,
};

const initialState = {};

const dynamicTableSlice = createSlice({
  name: 'dynamicTables',
  initialState,
  reducers: {
    initModule: (state, action) => {
      const { moduleKey } = action.payload;
      if (!state[moduleKey]) {
        state[moduleKey] = { ...defaultModuleState };
      }
    },
    setTableFilters: (state, action) => {
      const { moduleKey, filters } = action.payload;
      state[moduleKey].filters = { ...state[moduleKey].filters, ...filters };
    },
    setTableTempFilters: (state, action) => {
      const { moduleKey, tempFilters } = action.payload;
      state[moduleKey].tempFilters = { ...state[moduleKey].tempFilters, ...tempFilters };
    },
    setTableSearchValue: (state, action) => {
      const { moduleKey, searchValue } = action.payload;
      state[moduleKey].searchValue = searchValue;
    },
    setTablePagination: (state, action) => {
      const { moduleKey, currentPage, rowsPerPage } = action.payload;
      if (currentPage) state[moduleKey].currentPage = currentPage;
      if (rowsPerPage) state[moduleKey].rowsPerPage = rowsPerPage;
    },
    setTableData: (state, action) => {
      const { moduleKey, tableData, tableCount, lastFetchParams, ...extraData } = action.payload;
      state[moduleKey].tableData = tableData;
      state[moduleKey].tableCount = tableCount;
      state[moduleKey].lastFetchParams = lastFetchParams;

      Object.keys(extraData).forEach(key => {
        state[moduleKey][key] = extraData[key];
      });
    },
    resetTableState: (state, action) => {
      const { moduleKey } = action.payload;
      state[moduleKey] = { ...defaultModuleState };
    },
    resetAllTables: () => initialState,
  },
});

export const {
  initModule,
  setTableFilters,
  setTableTempFilters,
  setTableSearchValue,
  setTablePagination,
  setTableData,
  resetTableState,
  resetAllTables,
} = dynamicTableSlice.actions;

export default dynamicTableSlice.reducer;